import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import Label from '../../../components/label/Label';
import MultiSelect from '../../../components/select-field/MultiSelectField';

import messages from '../messages';

import './MultiSelectField.scss';

var MultiSelectField = function MultiSelectField(_ref) {
    var dataKey = _ref.dataKey,
        dataValue = _ref.dataValue,
        displayName = _ref.displayName,
        description = _ref.description,
        onChange = _ref.onChange,
        onRemove = _ref.onRemove,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? [] : _ref$options;

    var placeholder = React.createElement(FormattedMessage, messages.metadataFieldMultiSelectValue);

    return React.createElement(
        'div',
        { className: 'metadata-instance-editor-field-multi-select' },
        React.createElement(
            Label,
            { text: displayName },
            !!description && React.createElement(
                'i',
                { className: 'metadata-instance-editor-field-multi-select-desc' },
                description
            ),
            React.createElement(MultiSelect, {
                onChange: function (_onChange) {
                    function onChange(_x) {
                        return _onChange.apply(this, arguments);
                    }

                    onChange.toString = function () {
                        return _onChange.toString();
                    };

                    return onChange;
                }(function (selectedOptions) {
                    if (selectedOptions.length) {
                        onChange(dataKey, selectedOptions.map(function (_ref2) {
                            var value = _ref2.value;
                            return value;
                        }));
                    } else {
                        onRemove(dataKey);
                    }
                }),
                options: options.map(function (option) {
                    return {
                        displayText: option.key,
                        value: option.key
                    };
                }),
                placeholder: placeholder,
                selectedValues: dataValue
            })
        )
    );
};

MultiSelectField.propTypes = {
    dataKey: PropTypes.string.isRequired,
    dataValue: function dataValue() {
        return (typeof bpfrpt_proptype_FieldValue === 'function' ? bpfrpt_proptype_FieldValue : PropTypes.shape(bpfrpt_proptype_FieldValue)).apply(this, arguments);
    },
    description: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(function () {
        return (typeof bpfrpt_proptype_TemplateFieldOption === 'function' ? bpfrpt_proptype_TemplateFieldOption : PropTypes.shape(bpfrpt_proptype_TemplateFieldOption)).apply(this, arguments);
    })
};
export { MultiSelectField as MultiSelectFieldBase };
export default MultiSelectField;
import { bpfrpt_proptype_SelectOptionProp } from '../../../components/select-field/props';
import { bpfrpt_proptype_FieldValue } from '../flowTypes';
import { bpfrpt_proptype_TemplateFieldOption } from '../flowTypes';
import PropTypes from 'prop-types';